import { Block, RadioButtonUnchecked } from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';

const StatusCell = ({ readOnly }) => {
  return (
    <Box
      sx={{
        height: '100%',
        flex: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
        px: 1.5,
        py: 1,
        backgroundColor: '#eeeeee',
        borderRadius: 2,
      }}
    >
      {readOnly ? (
        <Block sx={{ color: 'error.main', fontSize: 20 }} />
      ) : (
        <RadioButtonUnchecked sx={{ color: 'success.main', fontSize: 20 }} />
      )}
    </Box>
  );
};

export { StatusCell };
